
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Method } from '../../../core/utils';

@Component
export default class StepperHeaders extends Vue {
    @Prop({ default: 1 }) step: number;
    @Prop({ default: true }) validateStepOne: boolean;
    @Prop({ default: true }) validateStepTwo: boolean;
    @Prop({ default: false }) shouldStepEditable: boolean;
    @Prop() updateStep: Method<number, void>;

    handleClick(step: number): void {
        if (this.shouldStepEditable) {
            this.updateStep(step);
        }
    }
}
